import React, { useState, useEffect } from 'react';
import { Condition } from '../condition';
import { BodyTextBoldSecondary } from '../typography';
import { Box } from '@/shared/ui/box';

const Timer = ({ triggerSlot, handleResend, onTimerEnd = () => {} }) => {
  const [timeLeft, setTimeLeft] = useState(() => {
    const savedTime = localStorage.getItem('timeLeft');
    return savedTime ? parseInt(savedTime, 10) : 0;
  });
  const [isActive, setIsActive] = useState(() => {
    const savedActiveState = localStorage.getItem('isActive');
    return savedActiveState ? JSON.parse(savedActiveState) : false;
  });

  useEffect(() => {
    let interval;
    if (isActive && timeLeft > 0) {
      interval = setInterval(() => {
        setTimeLeft((prevTime) => {
          const newTime = prevTime - 1;
          localStorage.setItem('timeLeft', newTime.toString());
          return newTime;
        });
      }, 1000);
    } else if (timeLeft === 0) {
      clearInterval(interval);
      setIsActive(false);
      localStorage.setItem('isActive', 'false');
      onTimerEnd();
    }
    return () => clearInterval(interval);
  }, [isActive, timeLeft]);

  const handleClick = () => {
    handleResend();
    const newTimeLeft = 120;
    setTimeLeft(newTimeLeft);
    setIsActive(true);
    localStorage.setItem('timeLeft', newTimeLeft.toString());
    localStorage.setItem('isActive', 'true');
  };

  const formatTime = () => {
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  return (
    <>
      <Condition match={!isActive}>
        <Box $cursor="pointer" onClick={() => handleClick()}>
          {triggerSlot}
        </Box>
      </Condition>
      <Condition match={isActive}>
        <BodyTextBoldSecondary color="#AFAFAF">
          Send again in {formatTime()}
        </BodyTextBoldSecondary>
      </Condition>
    </>
  );
};

export { Timer };
